










import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";

@Component
export default class UTransactionLink extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public transaction!: any;

  // Getters
  public get link() {
    return this.adminModalLink(this.transaction);
  }

  // Methods
  public adminModalLink(transaction) {
    return {
      type: "a",
      events: {
        click: () => {
          this.$store.dispatch(
            `data/${DataModules.PAYMENTS}/openTransactionModal`,
            {
              props: {
                transaction: this.$_.omit(transaction, [
                  "invoice",
                  "brand",
                  "client",
                  "_order"
                ])
              }
            }
          );
        }
      }
    };
  }
}
